import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh-CN'
import en from './en-US'
import kril from './kril-Kril'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'zh', // 默认语言
    fallbackLocale: 'en',
    messages: {
        zh,
        en,
        kril
    }
})

export default i18n